/* Shticky Bricks — scroll reveal for homepage sections.
   Adds .sb-reveal to each homepage section and .sb-in when visible. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function init() {
    var sections = document.querySelectorAll('main .shopify-section');
    if (!('IntersectionObserver' in window) || !sections.length) return;

    sections.forEach(function (el, i) {
      el.classList.add('sb-reveal');
      el.style.setProperty('--sb-reveal-delay', Math.min(i * 60, 240) + 'ms');
    });

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('sb-in');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );

    sections.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
